import { useMutation } from "react-query";
import { MedicalExaminationService } from "@services/medical-examination.service";

export const useDownloadGeneralMedicalExamControlsMutation = () => {
  return useMutation(MedicalExaminationService.downloadGeneralTable);
};
